const { innerWidth, innerHeight } = window;

export const isTablet = innerWidth < 1050;
export const isMobile = innerWidth < 500;
